import { HTMLProps } from 'react'
import clsx from 'classnames'
import style from './header-menu.module.scss'

interface HeaderMenuProps extends HTMLProps<HTMLDivElement> {
  onOpenModal: () => void
  open: boolean
}

export const HeaderMenu = (props: HeaderMenuProps) => {
  const { className, onOpenModal, open, children, onClick } = props

  return (
    <>
      <div className={clsx(style.container, className, { [style.open]: open })} onClick={onClick}>
        {children}
      </div>
      <div className={clsx(style.overflow, 'menu-close-trigger-js')} onClick={onClick} />
    </>
  )
}
